<div class="col-12 float-left mt-3 mb-3 _catalog-card-main">
  <div class="_catalog-card">
    <!-- <ng-container *ngIf="data.category_name">
    <div class="_catalog-card-left-section">
      <div class="_catalog-code-container">
        <span class="_catalog-code">{{data.category_code}}</span>
      </div>
      <div class="_catalog-image">
        <img src="{{ data.catalog_image_path }}">
      </div>
    </div>
    <div class="_catalog-card-right-section">
      <div class="_catalog-card-top-section">
        <h3>{{data.category_name}}</h3>
      </div>
      <div class="_catalog-description">
        <p>{{data.category_description}}</p>
      </div>
      <div class="_catalog-card-ratings">
        Ratings : <i class="fa fa-star active" aria-hidden="true"></i>
        <i class="fa fa-star active" aria-hidden="true"></i>
        <i class="fa fa-star active" aria-hidden="true"></i>
        <i class="fa fa-star active" aria-hidden="true"></i>
        <i class="fa fa-star" aria-hidden="true"></i>
      </div>
      <div class="_catalog-card-actions">
        <button class="primary-btn">More info</button>
      </div>
    </div>
  </ng-container> -->

  @if (data.product_name) {
    <!-- {{ data | json }} -->
    <div class="_catalog-card-left-section">
      <!-- <div class="_catalog-code-container">
      <span class="_catalog-code">{{data.product_code}}</span>
    </div> -->
    <div class="_catalog-image">
      <img src="{{ data.catalog_image_path }}">
    </div>
  </div>
  <div class="_catalog-card-right-section">
    <div class="_catalog-card-body">
      <div class="_catalog-card-top-section">
        <h3 class="_cat-card-title">{{data.product_name}}</h3>
        <div class="_catalog-code-container">
          <span class="_catalog-code">{{data.product_code}}</span>
        </div>
      </div>
      <div class="_catalog-description">
        <div [innerHTML]="data.product_short_description"></div>
      </div>
    </div>
    <div class="_catalog-card-actions">
      <!-- <button class="primary-btn">More info</button>
      <button class="secondary-btn">Add to cart</button> -->
      <!-- <button class="secondary-btn schedule-demo-btn" (click)="openScheduleDemoForm(this.data)">
      Schedule a demo
    </button>
    <button class="primary-btn download-brochure-btn" (click)="openDownloadBrochureForm(this.data)">
      Download Brochure
    </button> -->
    <button class="primary-btn more-detail-btn" (click)="openProductDetails(data)">
      More Details
    </button>
  </div>
</div>
}
</div>
</div>